import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./close-dialog-button.module.scss";
export const CloseDialogButton = (props) => {
    return (_jsx(IconButton, { className: styles.closeIcon, onClick: () => {
            props.onClick();
        }, size: "large", children: _jsx(CloseIcon, { fontSize: "inherit" }) }));
};
